export function validateProducaoAgroecologica(
    praticaAgroecologica: boolean | null,
    certificacoes: string[],
    otherCertifications: Array<{ description: string }>
): string | null {
    if (praticaAgroecologica === null) {
        return 'Informe se pratica produção agroecológica ou orgânica.';
    }
    if (praticaAgroecologica === true) {
        if (!certificacoes || certificacoes.length === 0) {
            return 'Selecione pelo menos um tipo de certificação.';
        }
        if (certificacoes.includes('OUTRO') && (!otherCertifications || otherCertifications.length === 0)) {
            return 'Adicione pelo menos uma certificação personalizada.';
        }
    }
    return null;
}

export const defaultAvailabilityMonths = {
    available_year_round: false,
    january: false,
    february: false,
    march: false,
    april: false,
    may: false,
    june: false,
    july: false,
    august: false,
    september: false,
    october: false,
    november: false,
    december: false,
};
